<template>
    <div class="termsOfPayment">
        <el-dialog title="请选择支付方式" :visible.sync="dialogTableVisible" :close-on-click-modal="false">
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="40px"
                class="demo-ruleForm"
            >
                <el-form-item prop="radio">
                    <el-radio-group v-model="ruleForm.radio" @change="radioChange">
                        <el-radio :label="1" v-if="onLineShow">线上支付</el-radio>
                        <el-radio :label="2" v-if="offLineShow">线下支付</el-radio>
                        <el-radio :label="3" v-if="platformShow">先行支付</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div v-if="offlineShow">
                    <el-form-item>
                        <p>请上传打款凭证（<font color="red">线下支付的交易订单，若需申请退款需线下协商处理</font>）</p>
                    </el-form-item>

                    <el-form-item prop="imageUrl">
                        <el-upload
                            class="avatar-uploader"
                            action="/service-center/upload/file/single"
                            :headers="headers"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload"
                        >
                            <img v-if="ruleForm.imageUrl" :src="ruleForm.imageUrl" class="avatar"/>
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                </div>
                <el-form-item>
                    <el-button @click="resetForm()">取消</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
                </el-form-item>
                <!-- <div class="termsOfPayment_btn">
                </div> -->
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import {
    getNewcurrent,
    offlinePay, onLineCheck
} from '../../utils/interface';

    export default {
        data() {
            return {
                dialogTableVisible: false,
                headers: {
                    Authorization: "Bearer " + this.$cookies.get("api_access_token"), //	可以是授权凭证用的参数值
                },
                offlineShow: false,
                ruleForm: {
                    radio: null,
                    imageUrl: "",
                },
                rules: {
                    radio: [
                        {required: true, message: '请选择支付方式', trigger: 'change'}
                    ],
                    imageUrl: [
                        {required: true, message: '请上传打款凭证', trigger: 'change'}
                    ],
                },
                onLineShow: false,
                offLineShow: false,
                platformShow: false,
            };
        },
        methods: {
            init(item) {
                this.$nextTick(()=>{
                    // DOM 更新了
                    console.log("dom update complete")
                    this.ruleForm.radio = null;
                    this.ruleForm.imageUrl = "";
                    this.ruleForm.order = item;
                    this.offlineShow = false;
                    this.dialogTableVisible = true;
                    this.onLineCheck(item.orderNo)
                    this.userCheck()
                    if (this.$refs.ruleForm) {
                        this.$refs.ruleForm.resetFields();
                    }
                })

            },
            onLineCheck(orderNo) {
                onLineCheck(orderNo).then(res=> {
                    if (res && res.success) {
                        res.data? this.onLineShow = true : this.onLineShow = false
                    }
                });
            },
            userCheck() {
                getNewcurrent()
                    .then((res) => {
                        if (res && res.identity == 'ENTERPRISE' && res.contract) {
                            this.platformShow = true
                        } else {
                            this.platformShow = false
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            radioChange() {
                if (this.ruleForm.radio == 2) {
                    this.offlineShow = true;
                } else {
                    this.offlineShow = false;
                }
            },
            handleAvatarSuccess(res, file) {
                this.ruleForm.imageUrl = res.url;
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type.indexOf('image') !== -1;
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error("上传凭证图片只能是图片格式!");
                }
                if (!isLt2M) {
                    this.$message.error("上传凭证图片大小不能超过 2MB!");
                }
                return isJPG && isLt2M;
            },

            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$emit('offlinePay', this.ruleForm);
                        this.dialogTableVisible = false
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm() {
                this.dialogTableVisible = false
            }
        },
    };
</script>

<style lang="less" scoped>
    /deep/ .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    /deep/ .el-upload:hover {
        border-color: #409eff;
    }

    /deep/ .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    /deep/ .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .termsOfPayment_btn {
        display: flex;
        justify-content: center;
        margin-top: 20px;

        button {
            margin-right: 16px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/termsOfPayment/termsOfPayment1.vue